const transponder = document.getElementById('app_dogtype_transponder');

if (transponder != null) {
  document.getElementById('app_dogtype_transponder').addEventListener('keyup', event => {
    if (event.key === 'Escape') {
      $('#app_dogtype_transponder').popover('hide');
    }
  });
}
